module.exports = __webpack_public_path__ + "static/img/1666.b08b6c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/s31/pop/1666.png
// module id = w6Fa
// module chunks = 2